import React from "react";
import { bool } from "prop-types";
import { Link } from "gatsby";
import "./Menu.css";

const Menu = () => {

  return (
      <nav className="main-menu">
        <Link to="/blog">Blog</Link>
        <Link to="/projects">
          Projecten
        </Link>
        <Link to="/over">Over</Link>
        {/* <Link to="Doneren">Doneren</Link> */}
                {/* <Link to="/podcast">Podcast</Link> */}
      </nav>
  );
};

export default Menu;
